import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as IntegrationSettingsModulePages from '@Modules/admin/integrationSettings/pages';

const integrationSettingsRoutes = [
  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.CARDHOLDER}
    element={<IntegrationSettingsModulePages.CardHolders />}
  />,

  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.MERCHANT}
    element={<IntegrationSettingsModulePages.Merchant />}
  />,

  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.SWITCH_AND_VISA_BASELL}
    element={<IntegrationSettingsModulePages.SwitchAndVisaBasell />}
  />,

  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU.ROOT}
    element={<IntegrationSettingsModulePages.BaseMenuRoutes />}
  >
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU
          .CENTER_COMMISSION_PARAMETERS
      }
      element={
        <IntegrationSettingsModulePages.CenterCommissionParametersPage />
      }
    />
    ,
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU
          .BANK_COMMISSION_PARAMETERS
      }
      element={<IntegrationSettingsModulePages.BankCommissionParametersPage />}
    />
    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU.BANK_ACCOUNT_ROUTING}
      element={<IntegrationSettingsModulePages.BankAccountRoutingPage />}
    />
    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU.BANK_RISK_MANAGEMENT}
      element={<IntegrationSettingsModulePages.BankRiskManagementPage />}
    />
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU.SENSITIVE_DATA_PARAMETERS
      }
      element={<IntegrationSettingsModulePages.SensitiveDataParametersPage />}
    />
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU
          .BANK_CARD_NUMBER_GENERATION_METHODS
      }
      element={
        <IntegrationSettingsModulePages.BankCardNumberGenerationMethodsPage />
      }
    />
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU.HPX_MODULES_MANAGEMENT
      }
      element={<IntegrationSettingsModulePages.HPXModulesManagementPage />}
    />
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU
          .SETTLEMENT_PROCESSING_PARAMETER
      }
      element={
        <IntegrationSettingsModulePages.SettlementProcessingParameterPage />
      }
    />
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU
          .BANK_TERMINAL_VERIFICATION_RESULT
      }
      element={
        <IntegrationSettingsModulePages.BankTerminalVerificationResultPage />
      }
    />
    <Route
      path={
        URLConfig.ADMIN.INTEGRATION_SETTINGS.BASE_MENU
          .BANK_CARD_VERIFICATION_RESULTS
      }
      element={
        <IntegrationSettingsModulePages.BankCardVerificationResultPage />
      }
    />
  </Route>,

  // ATM Menu Routes
  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.ROOT}
    element={<IntegrationSettingsModulePages.AtmMenuRoutes />}
  >
    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.STATES}
      element={<IntegrationSettingsModulePages.StatesPage />}
    />

    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.SCREEN}
      element={<IntegrationSettingsModulePages.ScreenPage />}
    />

    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.PARAMETER_VALUES}
      element={<IntegrationSettingsModulePages.ParameterValuesPage />}
    />

    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.OFFERED_SERVICES}
      element={<IntegrationSettingsModulePages.OfferedServicesPage />}
    />

    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.CONFIGURED_SERVICES}
      element={<IntegrationSettingsModulePages.ConfiguredServicesPage />}
    />

    <Route
      path={URLConfig.ADMIN.INTEGRATION_SETTINGS.ATM_MENU.REPLY_VALUES}
      element={<IntegrationSettingsModulePages.ReplyValuesPage />}
    />
  </Route>,

  // Batch Processing Menu Routes
  <Route
    path={URLConfig.ADMIN.INTEGRATION_SETTINGS.BATCH_PROCESSING}
    element={<IntegrationSettingsModulePages.BatchProcessingPage />}
  />,
];

export default integrationSettingsRoutes;
